interface FieldProps {
    title: string;
    value: string | number;
}

function Field(props: FieldProps) {
    const { title, value } = props;
    return (<div className="w-full h-fit mt-[30px]">
        <label className="text-title text-small">{title}</label>
        <p className="text-bold text-mid font-medium mt-[8px]">{value}</p>
    </div>);
}

export default Field;